import React, { useState, useEffect, forwardRef } from 'react';
import classNames from 'classnames';
import _ from 'lodash';

import './styles.scss';

const Select = forwardRef(({ variant, size, label, options, ...props }, ref) => {
  const { className, defaultValue, value, children, onChange } = props
  const [filled, setFilled] = useState()
  const prefix = 'form-control';
  const newClassName = classNames(prefix, variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, className);

  const handleChange = (e) => {
    setFilled(!!e.target.value)

    if (onChange) {
      onChange(e)
    }
  }

  useEffect(() => {
    setFilled(!!(defaultValue || value))
  }, [defaultValue, value])

  return (<>
    <select {...props}
      ref={ref}
      className={`${newClassName}${filled ? ' filled' : ''}`}
      onChange={handleChange}
    >
      {children}
      {!children && !(value || defaultValue) && <option value=""></option>}
      {options && options.map((option, i) =>
        <option key={i} {...option} label={option.label || option.value} />
      )}
    </select>
    {label && <label className="form-label" htmlFor={props.id}>
      {label}
    </label>}
  </>);
});

Select.displayName = 'Select'

export default Select;
